export default __webpack_public_path__ + "static/media/asset01.34132ace.png";